import { ImageDto } from "./image";
import { propertiesOf } from "../utils/propertyOf";

export const NEWS_ASPECT_RATIO = 1.0;

/** Mirrors kd-mem-server's [com.kurzdigital.kd_newss.server.dto.admin_api.AdminNewsDto] */
export interface News {
  branchId: number;
  publishAt: string;
  title: string;
  content: string;
  image?: ImageDto;
  externalUrl: string;
}

export const ofNews = propertiesOf<News>();

export const defaultNews: News = {
  branchId: 0,
  publishAt: "",
  title: "",
  content: "",
  externalUrl: "",
};
